import { useState } from "react";

// Kleines kreisförmiges Chicken-Logo (Header, Footer, Legal-Seiten).
// Das grosse Maskottchen wird bewusst NICHT mehr auf der Landingpage verwendet.
export const ChickenAvatar = ({ className = "h-8 w-8" }) => (
  <img
    src="/mascot/chickenwinner-mascot.webp"
    alt="ChickenWinner"
    className={`rounded-full ${className}`}
    loading="lazy"
    draggable="false"
  />
);

// Geometrisches SVG-Mark (für Favicon analog /public/favicon.svg)
export const ChickenMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="ChickenWinner Maskottchen">
    <rect width="64" height="64" rx="16" fill="#C49A42" />
    <circle cx="24" cy="13.5" r="4.5" fill="#D93B2B" />
    <circle cx="32" cy="11" r="5" fill="#D93B2B" />
    <circle cx="40" cy="13.5" r="4.5" fill="#D93B2B" />
    <circle cx="32" cy="37" r="17" fill="#FFFFFF" />
    <rect x="17" y="29" width="30" height="8.5" rx="4.25" fill="#111111" />
    <path d="M27.5 42.5h9L32 49z" fill="#C49A42" />
    <path d="M29.5 49.5c0 3.2 5 3.2 5 0z" fill="#D93B2B" />
  </svg>
);

const MASCOT_SRC = "/mascot/chickenwinner-mascot.png";

// Grosses Maskottchen (aktuell ungenutzt auf der Landingpage; für Social/Print behalten)
export const Mascot = ({ className = "", testId = "mascot" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div
        data-testid={testId}
        className={`flex aspect-square items-center justify-center rounded-full border border-gold/30 bg-offwhite ${className}`}
      >
        <ChickenMark className="h-2/3 w-2/3" />
      </div>
    );
  }
  return (
    <picture data-testid={testId}>
      <source srcSet="/mascot/chickenwinner-mascot.webp" type="image/webp" />
      <img
        src={MASCOT_SRC}
        onError={() => setFailed(true)}
        alt="ChickenWinner Maskottchen – Hahn mit schwarzer Sonnenbrille, Hoodie und verschränkten Armen"
        className={className}
        loading="lazy"
        draggable="false"
      />
    </picture>
  );
};
